<div
	class="flex flex-col items-center gap-8 my-12 mx-10"
	*ngIf="(currSetupStep$ | async) === StripeSetupStep.TRIAL_ENDED_NOTICE"
>
	<div class="flex justify-center">
		<img
			class="w-52"
			src="/assets/images/leap/setup-billing.png"
			alt="Setup billing"
		/>
	</div>

	<div class="flex flex-col items-center gap-5">
		<h1 class="font-medium text-3xl mb-0">Your Trial of Closer has Ended</h1>
		<p>
			To continue, simply add your billing details. There is no commitment, you
			can cancel anytime!
		</p>
	</div>

	<div class="flex justify-end">
		<ui-button
			preset="HIGH_EMPHASIS"
			label="Continue to billing"
			(click)="goToPromptForEmailAddrStep()"
		></ui-button>
	</div>
</div>

<div
	class="flex flex-col items-center gap-8 my-12 mx-10 min-w-[50vw]"
	*ngIf="(currSetupStep$ | async) === StripeSetupStep.PROMPT_FOR_EMAIL_ADDR"
>
	<div class="flex flex-nowrap items-center w-full">
		<h2 class="mr-3">Billing</h2>
		<p>provided by</p>
		<img class="max-w-24" src="/assets/images/stripe-logo.png" alt="Stripe" />
	</div>

	<div class="w-full">
		<app-container class="max-w-lg">
			<p>
				<strong>Note:</strong> You will be redirected to
				<a
					externalNavInterceptor
					href="https://stripe.com/"
					class="underline"
					target="_blank"
					rel="nofollow noreferrer noindex"
					>Stripe</a
				>'s website to fill in your credit card details. Your details are safely
				stored with Stripe. LawLabs Inc. does not store any credit card
				information on our platform.
			</p>
		</app-container>
	</div>

	<div
		*ngIf="createStripeCustomerError$ | async as createStripeCustomerError"
		class="w-full"
	>
		<app-container
			class="max-w-lg border-red-dark bg-red-lighter text-red-dark mb-6"
		>
			<h3 class="mb-3">There was an error.</h3>
			<p class="mb-3">
				Sorry, we encountered an error creating a Stripe customer account for
				your business. Please refresh the page to try again. If that fails,
				please
				<a emailLinkInterceptor href="mailto:support@lawlabs.ca"
					>contact support</a
				>.
			</p>
			<p>{{ createStripeCustomerError }}</p>
		</app-container>
	</div>

	<div class="w-full flex justify-center">
		<app-input-wrapper label="Enter Billing Email*" class="w-1/2">
			<app-input
				class="w-full"
				[formControl]="emailControl"
				placeholder="Email"
				type="email"
			></app-input>
		</app-input-wrapper>
	</div>

	<div class="flex justify-center gap-8">
		<ui-button
			preset="MEDIUM_EMPHASIS"
			label="Back"
			[disabled]="isProcessing$ | async"
			(click)="goToTrialEndedNoticeStep()"
		></ui-button>
		<ui-button
			preset="HIGH_EMPHASIS"
			label="Next"
			[loading]="isProcessing$ | async"
			[disabled]="nextBtnDisabled$ | async"
			(click)="navigateToStripe()"
		></ui-button>
	</div>
</div>
